import { Link } from "react-router-dom";
import { ArrowUpRight, BugOff, Cloud, CloudCog, Lock, Network, Settings2 } from "lucide-react";

const ICONS = {
  settings: Settings2,
  network: Network,
  bug: BugOff,
  "cloud-cog": CloudCog,
  cloud: Cloud,
  lock: Lock,
};

export default function ServiceCard({ service, to = "/service", testIdPrefix = "service-card", linkTestIdSuffix = "learn-more" }) {
  const Icon = ICONS[service.icon] || Settings2;
  return (
    <div
      data-testid={`${testIdPrefix}-${service.num}`}
      className="group relative flex h-full flex-col rounded-2xl border border-hairline bg-white p-8 shadow-[0_8px_30px_rgba(17,20,43,0.05)] transition-[transform,border-color,box-shadow] duration-300 ease-out hover:-translate-y-2 hover:border-iris hover:shadow-[0_24px_50px_rgba(108,59,255,0.15)]"
    >
      <div className="flex items-start justify-between">
        <span className="font-display text-sm font-extrabold tracking-widest text-steel/70 transition-colors duration-300 group-hover:text-iris">
          /{service.num}
        </span>
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-offwhite text-navy transition-all duration-300 group-hover:bg-iris group-hover:text-white">
          <Icon className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.8} />
        </span>
      </div>
      <h3 className="mt-7 font-display text-xl font-bold tracking-tight text-navy lg:text-2xl">{service.name}</h3>
      <p className="mt-3 flex-1 text-[15px] leading-relaxed text-steel">{service.desc}</p>
      <Link
        to={to}
        data-testid={`${testIdPrefix}-${service.num}-${linkTestIdSuffix}`}
        className="mt-8 inline-flex w-fit items-center gap-2 border-b-2 border-transparent pb-0.5 font-display text-sm font-bold text-iris transition-colors duration-300 hover:border-aqua hover:text-navy"
      >
        LEARN MORE
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </Link>
      <span className="pointer-events-none absolute inset-x-8 bottom-0 h-0.5 bg-gradient-to-r from-iris to-aqua opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
    </div>
  );
}
